





































































































































































import Vue from 'vue';

import * as ping from '@/lib/usage_ping';
import { Repository } from '@/db/_repo';
import { DeckService } from '@/lib/services/DeckService'
const db = new Repository();
const deckService = new DeckService();

import NewDeck  from '@/components/app/new-deck.vue';
import Explore  from '@/components/app-buttons/btnExplore.vue';
import DeckCard from '@/components/decks/deck-sm.vue';
import drop     from '@/components/app/app-home-dropdown.vue';
import { DeckSummaryModel } from '../../models/DeckSummaryModel';
import { mapGetters } from 'vuex';

export default {
    components: {
        'new-deck': NewDeck,
        'deck-card': DeckCard,
        'app-home-dropdown': drop,
        Explore,
    },
    data() {
        return {
            decks: [],
            firstLoadDecks: false,
            firstLoadShared: false,
            tourCallbacks: {
                onNextStep: function (currentStep) {
                    if (currentStep === 0) {
                        const btnNewDeck = document.getElementById('btnNewDeck');
                        btnNewDeck.click();
                    }
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'allDueDeckStats'
        ]),
        sortedDueDeckStats() {
            if(this.allDueDeckStats && this.allDueDeckStats.length > 0) {

            const group = this.allDueDeckStats.reduce((acc, stat) => {
                    if (!acc[stat.deckId]) {
                        acc[stat.deckId] = [];
                    }
                    acc[stat.deckId].push(stat);
                    return acc;
                    }, {})

            return group;

            }
        },
        steps() {
            return this.$store.state.tourSteps;
        },
        emptyState() {
            return (this.decks === null || this.decks.length < 1)
        },
        showAnything() {
            return (this.firstLoadDecks);
        },
        dueDecks: function() {
            return this.decks.filter(function(deck) {
                return deck.notificationCount > 0;
        })
   }
    },
    async created() {

        try {
            this.decks = await deckService.getDueDecksAsync(this.currentUser.uid);
            this.firstLoadDecks = true;
        }
        catch(e) {            
            console.error(e);
            this.$toast.open({
                message: 'There was an error fetching due cards.',
                type: 'error',
                duration: 3000,
                position: 'top-right'
            });
        }
    },
    methods: {
        startTour() {
            ping.send({ type: ping.UserUsage.starttour, uid: this.currentUser.uid });
            this.emptyState = false;
            this.$store.dispatch('toggleTour')
            this.$tours['myTour'].start()
            
        },
    }
}
